import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import BackToTop from './components/BackToTop';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Artificial preloader delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence mode="wait">
        {loading ? (
          <motion.div 
            key="preloader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className="fixed inset-0 z-[200] bg-background flex flex-col items-center justify-center gap-6"
          >
             <div className="relative">
                <motion.div 
                  initial={{ width: 0 }}
                  animate={{ width: "100%" }}
                  transition={{ duration: 1.5, ease: "easeInOut" }}
                  className="h-1 bg-accent-primary absolute bottom-0 left-0"
                />
                <h1 className="text-4xl sm:text-6xl font-display font-bold text-white tracking-widest uppercase">
                  Yash Patel<span className="text-accent-primary">.</span>
                </h1>
             </div>
             <motion.p 
               animate={{ opacity: [0, 1, 0] }}
               transition={{ repeat: Infinity, duration: 1.5 }}
               className="text-[10px] font-mono text-slate-500 uppercase tracking-[0.5em] mt-4"
             >
               Loading Digital Realm
             </motion.p>
          </motion.div>
        ) : (
          <motion.main 
            key="content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <CustomCursor />
            <BackToTop />
            <Navbar />
            
            <div className="mesh-gradient">
              <Hero />
              <div className="relative">
                 {/* Decorative line between sections */}
                 <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-32 bg-gradient-to-b from-accent-primary/50 to-transparent" />
                 <About />
                 <Skills />
                 <Projects />
                 <Experience />
                 <Contact />
              </div>
            </div>
            
            <Footer />
          </motion.main>
        )}
      </AnimatePresence>
    </>
  );
}

export default App;
